<template>
  <div class="goodFindCar w1400">
    <div class="goodFindCar-title font20">
      <span>当前位置：车货配载 > 货主找车</span>
      <div class="flexbox before">
        <el-input placeholder="请输入内容" v-model="input6">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class='btnnn font16 color ' @click="xiubox">我要发布</div>
      </div>
    </div>
    <div class="goodFindCar-cont">
      <div class="table-title cont-odd font20">
        <div>车辆类型</div>
        <div>车辆载重(吨)</div>
        <div>起始地点</div>
        <div>到货地点</div>
        <div>发布时间</div>
        <div>操作</div>
      </div>
      <div :class="[i%2==0?'table-item cont-even':'table-item cont-odd']" v-for="(item,i) in tableData">
        <div class="table-title font16">
          <div>{{item.ld005}}</div>
          <div>{{item.ld007}}</div>
          <div>{{item.ld002}}</div>
          <div>{{item.ld003}}</div>
          <div>{{item.ld004 | formatTime}}</div>
          <div @click="openInf(i)"  class="cus">展开</div>
        </div>
        <div class="ele-table font16" v-show="item.falg">
          <table>
            <tr>
              <td class="tdw14">车辆类型</td>
              <td class="tdw14">{{item.ld005}}</td>
              <td class="tdw7">载重</td>
              <td class="tdw7">{{item.ld007}}</td>
              <td class="tdw14">体积</td>
              <td class="tdw14">{{item.ld008}}</td>
              <td class="tdw14">发布时间</td>
              <td class="tdw21">{{item.ld004 | formatTime}}</td>
              <td class="tdw14">车牌号</td>
              <td class="tdw21">{{item.card}}</td>
            </tr>
            <tr>
              <td>起始地点</td>
              <td colspan="3">{{item.ld002}}</td>
              <td>到货地点</td>
              <td colspan="2">{{item.ld003}}</td>
              <td>收货电话</td>
              <td colspan="2">{{item.ld001}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]" :page-size="100" layout="sizes, prev, pager, next, jumper" :total="count">
      </el-pagination>
    </div>
    <div>
      <el-dialog :visible.sync="dialogVisible" width="268px" :before-close="handleClose">
        <div>
          <div class="font12 t-p">
            您好，如需发布需求，请扫描二维码
            前往小程序发布，谢谢配合！
          </div>
          <img src="../../assets/bc.png" alt="" class="bccode">
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [],
        dialogVisible: false,
        currentPage: 1,
        count: 0,
        pageSize: 10,
        input6: ''
      }
    },
    created() {
      this.getGoodsData()
    },
    watch: {
      input6() {
        this.currentPage = 1;
        this.pageSize = 10;
        this.getGoodsData();
      }
    },
    methods: {
      openInf(i) {
        this.tableData.forEach((ele, j) => {
          if (ele.falg) {
            ele.falg = !ele.falg;
            this.$set(this.tableData, j, ele)
          } else if (j == i) {
            ele.falg = !ele.falg;
            this.$set(this.tableData, j, ele)
          }
        })
      },
      getGoodsData() {
        if (this.input6.trim().length < 1) {
          this.getData();
        } else {
          this.getSearch();
        }
      },
      getData() {
        this.$axios.post('/api/truckInfo/list', {
          skip: (this.currentPage - 1) * this.pageSize,
          pageSize: this.pageSize
        }).then(res => {
          this.tableData = res.data.data;
          this.count = res.data.count;
        })
      },
      getSearch() {
        this.$axios.post('/api/truckInfo/search', {
          skip: (this.currentPage - 1) * this.pageSize,
          pageSize: this.pageSize,
          word:this.input6
        }).then(res => {
          this.tableData = res.data.data;
          this.count = res.data.count;
        })
      },
      xiubox() {
        this.dialogVisible = true;
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getGoodsData()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getGoodsData();
      }
    },
  }
</script>

<style scoped>
  .goodFindCar {
    position: relative;
    padding-bottom: 9.4rem;
    min-height: 80rem;
  }

  .goodFindCar-title {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 7rem;
    line-height: 7rem;
    padding: 0 2.7rem;
    background-color: #F6F5F5;
  }

  .flexbox {
    display: flex;
    flex-wrap: nowrap;
  }

  .btnnn {
    width: 15rem;
    text-align: center;
    border: none !important;
  }
  .before{
    align-items: center !important;
  }

  .goodFindCar-cont {
    overflow: hidden;
    width: 100%;
  }

  .table-title {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    align-items: center;
    text-align: center;
    height: 6rem;
    width: 100%;
  }

  .cont-even {
    background-color: #ECECEC;
  }

  .cont-odd {
    background-color: #F8F8F8;
  }

  .ele-table {
    padding-bottom: 1.5rem;
  }

  table {
    border-collapse: collapse;
    text-align: center;
  }

  td {
    border: 1px solid black;
    height: 4.8rem;
  }
  .cus{
     cursor: pointer;
   }
  .tdw7 {
    width: 7rem;

  }

  .tdw14 {
    width: 14rem;
  }

  .tdw21 {
    width: 21rem;
  }

  .page {
    position: absolute;
    bottom: 3.8rem;
    left: 50%;
    transform: translateX(-50%);
  }

  .bccode {
    display: block;
    width: 215px;
    height: 215px;
    margin: 28px auto 0;
    padding-bottom: 35px;
  }

  .el-dialog__body {
    padding: 10px 20px;
  }

  >>>.el-dialog__header {
    padding: 10px 20px 10px !important;
  }

  .el-dialog__headerbtn {
    top: 7px !important;
    right: 7px !important;
  }

  .t-p {
    padding: 10px 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/goodFindCar.vue